// removed by extract-text-webpack-plugin
module.exports = {"body":"_2GA8_","slide":"_3Div-","dots":"_163RL","dot":"PM85X","dot-active":"_1ZGNp","navigation":"UACY7","next":"_3cqjl","previous":"_1M3Z7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/TipCarousel.scss
// module id = ./src/components/Carousel/TipCarousel.scss
// module chunks = 0 2